import { Component } from '@angular/core';
@Component({
  selector: 'app-service-provider',
  templateUrl: './service-provider.component.html'
})
export class ServiceProviderComponent {

}
